import React from 'react';
import PropTypes from 'prop-types';
import { Route, withRouter, Redirect, Switch } from 'react-router-dom';
import { get } from 'lodash';
import NavBreadCrumb from '../../containers/NavBreadCrumb';
import ProgressTracker from '../../containers/ProgressTracker';
import Etapa1 from './Etapa1';
import Etapa2 from './Etapa2';

class Revisao extends React.Component {
  get id() {
    return get(this.props, 'match.params.id');
  }

  getCurrentPath() {
    return `Revisão ${this.id}`;
  }

  get canViewPlagiusDetector() {
    const permissions = get(this.props, 'permissions') || {};
    // eslint-disable-next-line
    return permissions.__all__ || permissions['itens.view_plagio'];
  }

  getSteps() {
    const { location: { pathname } } = this.props;

    return [
      {
        id: 1,
        title: 'Etapa 1',
        path: '/revisoes/:id/edit/1',
        link: `/revisoes/${this.id}/edit/1`,
        active: pathname === `/revisoes/${this.id}/edit/1`,
        component: props => (
          <Etapa1
            canViewPlagiusDetector={this.canViewPlagiusDetector}
            {...props}
          />
        ),
        disabled: false,
      },
      {
        id: 2,
        title: 'Etapa 2',
        path: '/revisoes/:id/edit/2',
        link: `/revisoes/${this.id}/edit/2`,
        active: pathname === `/revisoes/${this.id}/edit/2`,
        component: Etapa2,
        disabled: false,
      },
    ];
  }

  render() {
    const pathList = [{
      label: 'Objetos de aprendizagem',
      icon: 'list',
      link: '/itens',
    }];

    const steps = this.getSteps();

    return (
      <div>
        <NavBreadCrumb pathList={pathList} currentPath={this.getCurrentPath()} />
        <div className="container">
          <div className="row">
            <div className="col-md-3 mr-0">
              <ProgressTracker steps={steps} />
            </div>
            <div className="col-md-9">
              <Switch>
                {steps.map((step, index) => (
                  <Route
                    key={step.id}
                    path={step.path}
                    render={() => (step.disabled ? <Redirect to="/itens" /> : <step.component step={index} />)}
                  />
                ))}
                <Route path="/revisoes/:id/edit" render={() => <Redirect to={`/revisoes/${this.id}/edit/1`} />} />
                <Redirect to="/itens" />
              </Switch>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Revisao.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default withRouter(Revisao);
